import React from 'react';
import CheckboxNew from '../../../../components/CheckboxNew';
import Styles from './GroupMembers.module.scss';

interface IGroupMemebers{
  members:any;
  handleUpdateCheckStatus:any;
}
const GroupMemebers = ({ members, handleUpdateCheckStatus }:IGroupMemebers) => (
  <div className={Styles.wrapper}>
    {
      members?.map((list:any, index:number) => (
        <div key={index} className={Styles.wrapper__groupContainer}>
          <div className={Styles.wrapper__groupName}>{list?.group}</div>
          {
            list?.members?.map((details:any, index:number) => (
              <div className={Styles.wrapper__DetailsTitleAndCheck} key={index}>
                <CheckboxNew isLeftContent width="100%" name="" value={details?.checkMemeber} iconColor="white" backgroundColor={details?.checkMemeber ? 'rgba(18, 18, 18, 1)' : 'white'} height="fit-content" onClick={() => handleUpdateCheckStatus(details?.id, list?.group)} onChange={() => handleUpdateCheckStatus(details?.id, list?.group)}>
                  <span className={Styles.wrapper__checkContent}>
                    {' '}
                    {`${details?.firstName} ${details?.lastName}`}
                  </span>

                </CheckboxNew>
              </div>
            ))
          }
        </div>
      ))
    }
    <div />
  </div>
);

export default GroupMemebers;
